import { render, staticRenderFns } from "./Banner_Component.vue?vue&type=template&id=24e2f932&scoped=true&"
import script from "./Banner_Component.vue?vue&type=script&lang=js&"
export * from "./Banner_Component.vue?vue&type=script&lang=js&"
import style0 from "./Banner_Component.vue?vue&type=style&index=0&id=24e2f932&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e2f932",
  null
  
)

export default component.exports